module.exports = __webpack_public_path__ + "static/media/music-lover-radar.f5717d2d.png";